import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'financerazor';

  constructor(@Inject(PLATFORM_ID)
  private platformId: Object,
  ) { }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem('isPageRefreshed', 'true');
    }
  }
}
